(() => {
  const initCertificationCarousels = () => {
    document.querySelectorAll('[data-hth-certification-carousel]').forEach((carousel) => {
      if (carousel.dataset.carouselInitialized === 'true') return;

      carousel.dataset.carouselInitialized = 'true';

      const viewport = carousel.querySelector('[data-hth-certification-viewport]');
      const slides = [...carousel.querySelectorAll('[data-hth-certification-slide]')];
      const dots = [...carousel.querySelectorAll('[data-hth-certification-dot]')];
      const previous = carousel.querySelector('[data-hth-certification-previous]');
      const next = carousel.querySelector('[data-hth-certification-next]');
      const status = carousel.querySelector('[data-hth-certification-status]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      let activeIndex = 0;
      let scrollFrame;

      if (!viewport || slides.length < 2 || !previous || !next) return;

      const updateControls = (index) => {
        activeIndex = Math.max(0, Math.min(index, slides.length - 1));
        previous.disabled = activeIndex === 0;
        next.disabled = activeIndex === slides.length - 1;

        slides.forEach((slide, slideIndex) => slide.setAttribute('aria-hidden', slideIndex === activeIndex ? 'false' : 'true'));
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        if (status) status.textContent = `${activeIndex === 0 ? 'Certification flyer' : 'Class photo'}, image ${activeIndex + 1} of ${slides.length}`;
      };

      const goToSlide = (index) => {
        const targetIndex = Math.max(0, Math.min(index, slides.length - 1));
        viewport.scrollTo({ left: targetIndex * viewport.clientWidth, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
        updateControls(targetIndex);
      };

      previous.addEventListener('click', () => goToSlide(activeIndex - 1));
      next.addEventListener('click', () => goToSlide(activeIndex + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => goToSlide(index)));

      viewport.addEventListener('scroll', () => {
        window.cancelAnimationFrame(scrollFrame);
        scrollFrame = window.requestAnimationFrame(() => {
          const index = Math.round(viewport.scrollLeft / viewport.clientWidth);
          if (index !== activeIndex) updateControls(index);
        });
      }, { passive: true });

      window.addEventListener('resize', () => viewport.scrollTo({ left: activeIndex * viewport.clientWidth, behavior: 'auto' }), { passive: true });
      updateControls(0);
    });
  };

  const initHomepageMotion = () => {
    const homepage = document.querySelector('.hth-ecosystem');

    if (!homepage || homepage.dataset.motionInitialized === 'true') return;

    homepage.dataset.motionInitialized = 'true';

    const revealItems = [
      ...homepage.querySelectorAll('.hth-section, .hth-home-footer'),
      ...homepage.querySelectorAll('.hth-proof-card'),
    ];

    revealItems.forEach((item) => item.setAttribute('data-hth-reveal', ''));

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('hth-is-visible'));
      return;
    }

    homepage.classList.add('hth-motion-ready');

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const hasEnteredViewport = entry.isIntersecting || entry.boundingClientRect.top < 0;

          if (!hasEnteredViewport) return;

          entry.target.classList.add('hth-is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08,
      }
    );

    revealItems.forEach((item) => observer.observe(item));

    let revealFramePending = false;

    const revealPassedItems = () => {
      revealFramePending = false;
      let itemsRemain = false;

      revealItems.forEach((item) => {
        if (item.classList.contains('hth-is-visible')) return;

        if (item.getBoundingClientRect().top < window.innerHeight * 0.92) {
          item.classList.add('hth-is-visible');
          observer.unobserve(item);
        } else {
          itemsRemain = true;
        }
      });

      if (!itemsRemain) window.removeEventListener('scroll', scheduleRevealCheck);
    };

    const scheduleRevealCheck = () => {
      if (revealFramePending) return;

      revealFramePending = true;
      window.requestAnimationFrame(revealPassedItems);
    };

    window.addEventListener('scroll', scheduleRevealCheck, { passive: true });
    scheduleRevealCheck();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initCertificationCarousels();
      initHomepageMotion();
    }, { once: true });
  } else {
    initCertificationCarousels();
    initHomepageMotion();
  }
})();
